import { useDispatch, useSelector } from 'react-redux';
// Typed Redux hooks. Kept separate from `store.ts` so components can depend on
// the hooks without importing the store module — which builds the RTK Query
// APIs at load time (and needs a configured API base URL). The `import type`
// above is erased at compile time, so this file has no runtime store dependency.
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
